import { render, staticRenderFns } from "./DialogDeleteTaxe.vue?vue&type=template&id=5d3d6e5c"
import script from "./DialogDeleteTaxe.vue?vue&type=script&lang=js"
export * from "./DialogDeleteTaxe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports